var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 65,
    viewBox: "0 0 142 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84 35H0C0 25.8183 7.43556 18.375 16.6078 18.375C18.3781 18.375 20.0838 18.6523 21.6838 19.1658C24.6468 8.12649 34.7142 0 46.6776 0C58.8656 0 69.0856 8.43443 71.8307 19.7905C78.6465 21.59 83.7221 27.68 84 35Z",
    fill: "#E9F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6012 0.49823C52.9843 2.50005 61.5699 10.3057 62.0404 19.7453C68.9443 21.4858 74.1046 27.6173 74.385 35H70.8016L0 35C0 25.8183 7.43556 18.375 16.6078 18.375C18.3781 18.375 20.0838 18.6523 21.6838 19.1659C24.2165 9.72972 31.9399 2.42183 41.6012 0.49823Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142 30H97C97 25.0156 100.983 20.975 105.897 20.975C106.845 20.975 107.759 21.1255 108.616 21.4043C110.204 15.4115 115.597 11 122.006 11C128.535 11 134.01 15.5787 135.481 21.7435C139.132 22.7203 141.851 26.0263 142 30Z",
    fill: "#E9F7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.286 11.2704C125.385 12.3571 129.984 16.5945 130.236 21.7189C133.935 22.6638 136.699 25.9923 136.849 30H134.93L97 30C97 25.0156 100.983 20.975 105.897 20.975C106.845 20.975 107.759 21.1255 108.616 21.4043C109.973 16.2818 114.111 12.3147 119.286 11.2704Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94 65H48C48 60.0156 52.0719 55.975 57.0947 55.975C58.0642 55.975 58.9983 56.1255 59.8745 56.4043C61.4971 50.4115 67.0102 46 73.5616 46C80.236 46 85.8327 50.5787 87.3359 56.7435C91.0683 57.7203 93.8477 61.0263 94 65Z",
    fill: "#E9F7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7817 46.2704C77.0153 47.3571 81.717 51.5945 81.9746 56.7189C85.7553 57.6638 88.5812 60.9923 88.7347 65H86.7724L48 65C48 60.0156 52.0719 55.975 57.0947 55.975C58.0642 55.975 58.9983 56.1255 59.8745 56.4043C61.2615 51.2818 65.491 47.3147 70.7817 46.2704Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5561 37.1751L88.3552 5.14895L59.0891 41.6201L58.25 50.94L51.5561 37.1751Z",
    fill: "#017BC6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3552 5.14924L37.8283 31.0038L51.556 37.1754L88.3552 5.14924Z",
    fill: "#37B9FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2498 50.94L88.355 5.14893L59.0889 41.6201L58.2498 50.94Z",
    fill: "#00A5FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0384 50.046L88.3553 5.14896L59.089 41.6201L78.0384 50.046Z",
    fill: "#37B9FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSuccess);
export default __webpack_public_path__ + "static/media/email_success.3660741f.svg";
export { ForwardRef as ReactComponent };